import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { setDashboardComponent } from '../../actions/index';

import TableParent from '../../../adminpanel/components/commonComponents/TableParent';

import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';

class PinboardList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...props };
        this.buttons = {
            "addButton": [{ "label": "Add", "type": "normal", "display": false, "action": "add" }],
            "dropdownConfig": [{
                "label": "More", "type": "dropdown", "display": true,
                "children": [
                    // {  "label": "File Format Download", "action": "file" },
                    { "label": "Export CSV", "action": "export" },
                    // { "label": "Import CSV", "action": "import" },
                ]
            }],
            "editButton": [{ "class": "", "label": "Edit", "type": "normal", "display": true, "action": "edit" }],
            "saveButton": [{
                "class": "", "label": "Save", "type": "normal", "display": false, "action": "save"
            }],
            "cancelButton": [{ "class": "", "label": "Cancel", "type": "normal", "display": false, "action": "cancel" }]
        }
        this.change_handle = this.change_handle.bind(this);
        this.change_table_format = this.change_table_format.bind(this);
        this.saveHandle = this.saveHandle.bind(this);
    }
    change_handle(data) {
        let newData = this.state.dashbordGroups

        newData[data.node.id][data.colDef.field] = data.value

        this.setState({ dashbordGroups: newData })
    }
    change_table_format(array_data) {

        try {
            var that = this;
            let temp_array = [];
            let groupArray = [];

            array_data.map(function (innerData, index) {

                let inner_temp_array = innerData;
                inner_temp_array.dashboard_id = innerData.idDashboard;
                inner_temp_array.setData = ["name", "dashboard_group", "dashboard_dequence", "isDisplay"];

                temp_array.push(inner_temp_array);

                groupArray[innerData.dashboard_group] = innerData.dashboard_group;

            })

            return { data: temp_array, dashboard_group: groupArray };
        }
        catch (e) {
            return "error";
        }
    }
    saveHandle(e) {
        let dataset = this.props.dataSet, checkValidity = true;
        var that = this;
        that.state.dashbordGroups && that.state.dashbordGroups.map(function (innerData) {
            checkValidity = checkValidity ? (checkSpecialChars(innerData.name) ? false : true) : false
            checkValidity = checkValidity ? (innerData.isDisplay === '0' || innerData.isDisplay === '1' ? true : false) : false
            checkValidity = checkValidity ? (checkSpecialChars(innerData.dashboard_dequence, 'number') ? true : false) : false
        })
        if (checkValidity === false) {
            alert('Please enter valid inputs!');
        } else {
            CallAPI("POST", "/app/changeDashboardName", this.state.dashbordGroups, { siteId: dataset.siteId, toolId: dataset.toolId }, 0, function (responseData) {
                alert("Successfully Submitted");
                that.props.setDashboardComponent({ 'siteId': `${dataset.siteId}`, 'toolId': `${dataset.toolId}`, 'userId': that.props.authData.userId, 'sessionId': that.props.authData.sessionId })
            }, this.props.authData)
        }
    }
    render() {

        let mainData = null;

        if (this.props.dashbordGroups) {

            let final_data = this.change_table_format(this.state.dashbordGroups);

            var columns_array = [
                { label: "Dashboard Name", value: "name", type: "html", editable: true, hide: false, dataType: 'string' },
                { label: "Dashboard group", value: "dashboard_group", type: "html", dropdown_value: Object.values(final_data.dashboard_group), editable: true, hide: false, dataType: 'string' },
                { label: "Dashboard Id", value: "idDashboard", type: "html", editable: true, hide: true, dataType: 'string' },
                { label: "Sequence", value: "dashboard_dequence", type: "html", editable: true, hide: false, dataType: 'string' },
                { label: "Display", value: "isDisplay", type: "html", editable: true, hide: false, dataType: 'string' }
            ];

            mainData = <TableParent
                data={final_data}
                columns_array={columns_array}
                firstColumnShow={false}
                firstColumn="sample"
                onCellChange={this.change_handle}
                filename="Dashboards List"

                // actionArray={this.props.menuData}
                // menuAction={this.handleMenuAction}
                // handleDataUpdate={this.handleDataUpdate}
                submitHandle={this.saveHandle}
                buttonConfig={this.buttons}
                rowSelection="multiple"
            // firstCellRender={this.formatColumnStatus}
            />
        }

        return (
            <>
                {mainData}
            </>
        )
    }
}

function mapStateToProps(state) {

    metricGlobal = state.dataSet.metricGlobal; metricFunction = state.dataSet.metricFunction;
    document.title = `Dashboard List | Cognitive Analytics Platform`;

    return {
        authData: state.dataSet.authData,
        dataResult: state.dataSet.dataResult,
        dataSet: state.dataSet.dataSet,
        dataset_info: state.dataSet,
        dashbordGroups: state.dataSet.dashbordGroups,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setDashboardComponent
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PinboardList);
